<template>
  <div class="close-visit-plan-full-screen-page">
    <popup ref="popup"
      class="full-page"
      fullScreen
      :visible="true">
      <title-bar
        :title="title"
        @back="hide"
        show-back
      ></title-bar>
      <div class="top">
        <i class="richic-warn"></i>
        <p v-text="wranText"></p>
      </div>
      <soda-form
        ref="form"
        v-model="formData"
        :config="config"
      />
      <div
        class="submit-wrap"
      >
        <rich-button type="submit"
          @click="submitHandler">{{$t('FoodB_address_Submission_cfyI' /** '提交' */)}}</rich-button>
      </div>
    </popup>
  </div>
</template>
<script>
import { i18n, getBDCountry } from '@/common/utils/i18n'
import VueI8n from '@/i18n/locale'
import { configParser } from '@/config/visit/addvisit/methods.js'
import { closeVisitPlan } from '@/api/visit/index.js'
import popup from '@/components/Popup'
import SodaForm from '@/components/form/index'
import TitleBar from '@/components/TitleBar.vue'

const country = getBDCountry() || 'MX'
let config = [
  {
    label: i18n.gettext('请录入关闭原因'),
    type: 'textarea',
    prop: 'visitCloseReason',
    props: {
      class: 'rich-textarea-wrapper-visit-content'
    },
    rules: [['required']]
  }
]
export default {
  name: 'FullScreenCloseVisit',
  components: {
    popup,
    SodaForm,
    TitleBar
  },
  props: {
    visitId: {
      required: true,
      type: [String, Number]
    }
  },
  data () {
    return {
      title: VueI8n.t('FoodOpB_1_Close_visit_ttxh' /** 关闭拜访确认 */),
      wranText: VueI8n.t('FoodOpB_1_Are_you_sLNY' /** 确定关闭本次拜访？关闭后拜访失效不可录入 */),
      formData: {},
      config: []
    }
  },
  created () {
    this.config = configParser(config, country)
  },
  methods: {
    show () {
      this.$refs.popup.show()
    },
    hide () {
      this.$refs.popup.hide()
      setTimeout(() => {
        this.remove()
      }, 200)
    },
    confirm () {
      this.$emit('confirm')
    },
    async submitHandler () {
      // 缺失 rules 校验
      let pass = await this.$refs.form.validate()
      if (!pass) {
        return false
      }
      closeVisitPlan({
        visitId: this.visitId,
        closeReason: this.formData.visitCloseReason
      }).then(() => {
        this.confirm()
      })
    }
  }
}
</script>
<style lang="scss">
.close-visit-plan-full-screen-page {
  .popup {
    .popup-panel {
      .popup-choose {
        display: none; // 隐藏 popup 的 titlebar
      }
    }
  }
  .rich-textarea-wrapper-visit-content {
    height: 80Px;
  }
}
</style>
<style lang="stylus" scoped>
.close-visit-plan-full-screen-page
  position: relative
  overflow: hidden
  height: 100%
  .top
    padding: 30px 0 50px
    text-align: center
    .richic-warn
      font-size: 60px
      color: #ff5253
    p
      margin-top: 30px
      color: #333
      font-size: 32px
  .submit-wrap
    position: absolute
    bottom: 0
    width: 100%
    z-index: 8
</style>
